<template>
    <div class="introduce_item">
        <div class="title" :class="`icon_${number}`">{{ title }}</div>
        <div class="image_card">
            <div :class="image.length>1?'image_2':'image_1'" v-for="(item,index) in image" :key="index">
                <img :src="item" />
            </div>
        </div>
        <div style="clear:both"></div>
    </div>
</template>
<script>
    export default {
        name: 'introduceItem',
        props: {
            title: {
                type:String,
                default:''
            },
            number: {
                type:[ String, Number],
                default:1
            },
            image: {
                type:Array,
                default:() => []
            }
        },
    }
</script>
<style scoped lang="less">
.introduce_item{
    margin-bottom: 60px;
    .title{
        font-size: 30px;
        color: #000000;
        display: flex;
        align-items: center;
        margin-bottom: 40px;
        &::before {
            content: ' ';
            background-size: 34px 34px;
            height: 34px;
            width: 34px;
            display: inline-block;
            margin-right: 10px;
        }
    }
    .image_card{
        margin-left: 8px;
    }
    .image_1{
        margin-left: 40px;
        width: 590px;
        img{
            width: 100%;
            height: auto;
        }
    }
    .image_2{
        float: left;
        width: 325px;
        margin-right: 20px;
        &:last-child {
            margin-right: 0px;
        }
        img{
            width: 100%;
            height: auto;
        }
    }
    .icon_1{
        &::before{
            background-image: url('../../../assets/icon/step-01.png');
        }
    }
    .icon_2{
        &::before{
            background-image: url('../../../assets/icon/step-02.png');
        }
    }
}
</style>
